import { useState, type ReactNode } from 'react';

import { useModalStore, type ModalStateUnion } from './modal.store';

interface OpenModalOptions {
  additionalContent?: ReactNode;
  additionalProps?: Record<string, unknown>;
  useLocalWhenOpen?: boolean;
}

export function useModalWithLocalFallback() {
  const { openModal, isModalOpen } = useModalStore();
  const [isLocalModalOpen, setIsLocalModalOpen] = useState(false);

  const open = (modalState: ModalStateUnion, options: OpenModalOptions = {}) => {
    const { additionalContent, additionalProps, useLocalWhenOpen = true } = options;

    if (isModalOpen && useLocalWhenOpen) {
      setIsLocalModalOpen(true);

      return;
    }

    openModal(modalState, additionalContent, additionalProps);
  };

  const closeLocalModal = () => setIsLocalModalOpen(false);

  return {
    open,
    closeLocalModal,
    isLocalModalOpen,
  };
}
